import { SET_CALC_AFECTO } from '../actionTypes/percentil'

const initialState = {
  preocupacion: 0,
  contento: 0,
  tranquilo: 0,
  desanimo: 0,
  optimista: 0,
  satisfecho: 0,
  irritable: 0,
  decepcionado: 0,
  bienestar: 0,
  malestar: 0,
  afectoX: 0,
  afectoY: 0
}

const Percentil = (state = initialState, action) => {
  console.log(action.type, 'action.type')
  switch (action.type) {
    case SET_CALC_AFECTO:
      console.log(action.type, 'action.type')
      return {
        ...state,
        ...action.payload
      }

    default: return state
  }
}

export {
  Percentil
}



// WEBPACK FOOTER //
// ./src/redux/reducers/percentil.js